import { useState, type FormEvent } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, signIn } from "../api.js";

export function InvitePage({ onSignedIn }: { onSignedIn: () => Promise<void> }) {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const created = await api<{ email: string }>("/api/internal/invitations/accept", {
        method: "POST",
        body: JSON.stringify({ token, name, password }),
      });
      setEmail(created.email);
      await signIn(created.email, password);
      await onSignedIn();
      navigate("/jobs", { replace: true });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "无法接受邀请。");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page invite-page" id="main-content">
      <section className="auth-panel">
        <div className="auth-brand">
          <span className="brand-tile large-brand">R</span>
          <div>
            <strong>RoleWorth</strong>
            <small>创建个人工作区</small>
          </div>
        </div>
        <div className="auth-copy">
          <p className="eyebrow">收到邀请</p>
          <h1>建立你的机会资料库</h1>
          <p>你的职位、评论、评分和 Agent 凭据会与其他用户完全隔离。</p>
        </div>
        <form className="auth-form" onSubmit={submit}>
          <label>
            显示名称
            <input required maxLength={120} value={name} onChange={(event) => setName(event.target.value)} />
          </label>
          <label>
            密码
            <input
              type="password"
              required
              minLength={12}
              maxLength={128}
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <small>至少 12 个字符</small>
          </label>
          {email && <p className="success-note">账号已创建：{email}</p>}
          {error && (
            <p className="form-error" role="alert">
              {error}
            </p>
          )}
          <button className="button primary" type="submit" disabled={busy}>
            {busy ? "正在创建" : "接受邀请"}
          </button>
        </form>
        <footer>
          <Link to="/privacy">隐私说明</Link>
          <Link to="/terms">使用条款</Link>
        </footer>
      </section>
    </main>
  );
}
